import React, {useState} from 'react'
import {Button, Modal} from "react-bootstrap";
import Notifications from "../Notifications";
import {DataAPI, MutationAPI, useData, useMutator} from "../../services/API";
import {RouteComponentProps, useParams} from "react-router-dom";
import type {LocationWebInfo} from "../../services/API";
import {ModalUrl, useHandleClose} from "../../commons/ModalHelpers";
import {useQueryClient} from "react-query";
import LocationsTab from "../LocationsTab";

const DeleteLocation = (props: RouteComponentProps) => {

    const { id } = useParams();
    const [firstRun, setFirstRun] = useState(true);
    const [msg, setMsg] = useState(null);
    const queryClient = useQueryClient();

    const { isLoading, error, data } = useData(id, 'location', DataAPI.getLocation);

    const handleClose = useHandleClose(LocationsTab.url);
    const deleteLocation = useMutator(MutationAPI.deleteLocation, {
        notifyExecute: false,
        afterSuccess: (data)=>{
            if (data) {
                setMsg(data);
                setFirstRun(false)
            } else {
                queryClient.invalidateQueries('location-list');
                queryClient.removeQueries(['location', id], { exact: true });
                //notyfikujemy dopiero przy 2 runie
                Notifications.pushNew('Akcja wykonana', 'info');
                handleClose();
            }
        }
    });

    const handleDelete = () => deleteLocation.mutate({ lwi: location, firstRun });

    if (isLoading) return null;
    if (error) {
        Notifications.pushNew(error.message, 'danger');
        return null;
    }

    const location: LocationWebInfo = data;

    return (
        <Modal size="sm" show={true} onHide={handleClose} animation={false}>
            <Modal.Header closeButton>
                <Modal.Title>Usuń lokację</Modal.Title>
            </Modal.Header>
            <Modal.Body className="confirm-body">
                <p>Czy na pewno chcesz usunąć lokację <strong>{location.name}</strong>?</p>
                {msg ? <p className="text-danger">{msg}</p> : null}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-secondary" onClick={handleClose}>Anuluj</Button>
                <Button variant="danger" onClick={handleDelete}>Usuń</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default DeleteLocation;

DeleteLocation.url = `/locations${ModalUrl}delete/:id`
DeleteLocation.buildUrl = location => DeleteLocation.url.replace(':id', location ? location : 'new')